<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOpen]="true"
  [cdkConnectedOverlayOrigin]="body"
  [cdkConnectedOverlayHasBackdrop]="hasBackdropSg()"
  [cdkConnectedOverlayBackdropClass]="backdropClassSg()"
  [cdkConnectedOverlayPositionStrategy]="positionSg()"
  (overlayOutsideClick)="$event.stopPropagation(); backdropClick.emit($event)"
>
  <div [style]="styleSg()">
    <ng-content></ng-content>
  </div>
</ng-template>
